import { render, staticRenderFns } from "./_base-footer.vue?vue&type=template&id=7b5d2b43&scoped=true&"
import script from "./_base-footer.vue?vue&type=script&lang=js&"
export * from "./_base-footer.vue?vue&type=script&lang=js&"
import style0 from "./_base-footer.vue?vue&type=style&index=0&id=7b5d2b43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5d2b43",
  null
  
)

export default component.exports